<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Demande de contrat</span>
        <h3 class="page-title">Employés</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4 mt-3" v-if="loading || !user.connected">
          <div class="card-body">
            <spinner-dot />
          </div>
        </div>
        <div v-else>
          <div class="card card-small mb-4 mt-3">
            <div class="header-data-table">
              <h5 class="header-data-table__heading">Liste des employés</h5>
            </div>
            <EmployeeFilter />
            <div class="card-body">
              <data-table :data="employeeGridData" :fields="gridColumnsTitle" :selectedFields="employeeFields"
                :fieldsGrid="gridColumnsFields" :tableState="state" :count="count"></data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import DataTable from "../../components/contract/dataTable";
import absceneRequestGrid from "../../data/dataTable/absceneRequestGrid.json";
import EmployeeFilter from "./EmployeeFilter.vue";

export default {
  name: "employee-management",
  components: {
    DataTable,
    SpinnerDot,
    EmployeeFilter,
  },
  props: ["reference"],
  data() {
    return {
      dialog: false,
      employeeHistory: [],
      requestToEdit: {},
      count: 0,
      model: {},
      gridColumnsFields: absceneRequestGrid.grid,
      gridColumnsTitle: absceneRequestGrid.grid.map((grid) => grid.title),
      loading: true,
      employeeFields: ["Employé", "Type de contrats", "Action"],

      employeeFieldsGridFill: {
        Employé: (request) => request.firstName + " " + request.lastName,
        "Type de contrats": (request) => request.typeOfContracts,
        Action: (request) => {
          return [
            {
              component: "button-td",
              class: "btn-accent",
              content: "Voir l'employé",
              action: () => this.goToRequest(request),
              id: request.declineReason,
            },
          ];
        },
      },
      state: {
        page: 1,
        perPage: 10,
        field: "Date de création",
        ascending: false,
      },
      filterQuery: {},
      filteredEmployee: [],
      employeeGridData: [],
    };
  },

  watch: {
    state: {
      handler() {
        this.employeeFetch();
      },
      deep: true,
    },
    filterQuery() {
      if (Object.keys(this.filterQuery).length === 0) {
        this.employeeFetch();
      } else {
        this.searchEmployee();
      }
    },
    employeeHistory() {
      this.filteredEmployee = this.employeeHistory;
    },
    filteredEmployee() {
      this.employeeGridData = this.filteredEmployee.map((user) => {
        const res = {};
        this.employeeFields.forEach((field) => {
          if (this.employeeFieldsGridFill[field]) {
            res[field] = this.employeeFieldsGridFill[field](user);
          }
        });
        return res;
      });
    },
  },

  computed: {
    user() {
      return this.$store.state.user.informations;
    },
  },

  methods: {
    goToRequest(request) {
      this.$router.push(`/employee/${request.reference}`);
    },
    async employeeFetch() {
      this.loading = true;
      const types = ["CP", "CS", "OTHER"];
      await this.$services.employeeService
        .findAll(
          Object.assign({}, {}, {}),
          null,
          null,
          this.state.page,
          this.state.perPage,
          this.state.field,
          this.state.ascending,
          this.gridColumnsFields
        )
        .then((res) => {
          this.loading = false;
          this.count = res.data.count;
          this.employeeHistory = res.data.data;
        });
    },
    async searchEmployee() {
      this.loading = true;
      await this.$services.employeeService
        .findAllUnderCharge(this.user.reference, {
          firstName: this.filterQuery.firstName
            ? this.filterQuery.firstName
            : undefined,
          lastName: this.filterQuery.lastName
            ? this.filterQuery.lastName
            : undefined,
          typeOfContracts: this.filterQuery.typeOfContracts
            ? this.filterQuery.typeOfContracts
            : undefined,
        })
        .then((res) => {
          this.loading = false;
          this.count = res.data.count;
          this.employeeHistory = res.data;
        });
    },
  },

  mounted() {
    if (!this.reference) {
      this.model = { userReference: this.user.reference };
    } else {
      this.model = { userReference: this.reference };
    }
    this.filterQuery = this.$store.state.absenceRequest.filter;
    this.employeeFetch();
    this.$root.$on("refresh", () => {
      this.employeeFetch();
    });
    this.$root.$on("searchRequests", (query) => {
      this.filterQuery = query;
    });
  },
};
</script>

<style></style>
